import { OrderPayment, OrderPaymentCC, PaymentTypeCode } from '../order'

export const isOrderPaymentCC = (payment: OrderPayment): payment is OrderPaymentCC =>
  payment.typeCode === PaymentTypeCode.enum.CC
